export default __webpack_public_path__ + "static/media/business.3d3a8d1d.svg";